import React from 'react';
import { Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-amber-500/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-2">SCOTT PARRISH</h3>
            <p className="text-gray-400 text-sm">
              Visual Designer & Creative Director
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <a href="/" className="block text-gray-400 hover:text-amber-400 transition-colors duration-300 text-sm">
                Home
              </a>
              <a href="/about" className="block text-gray-400 hover:text-amber-400 transition-colors duration-300 text-sm">
                About
              </a>
              <a href="/work" className="block text-gray-400 hover:text-amber-400 transition-colors duration-300 text-sm">
                Work
              </a>
              <a href="/contact" className="block text-gray-400 hover:text-amber-400 transition-colors duration-300 text-sm">
                Contact
              </a>
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold mb-4">Connect</h4>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/in/scott-e-parrish/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-amber-400/20 border border-amber-400/20 hover:border-amber-400 flex items-center justify-center text-gray-400 hover:text-amber-400 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="mailto:scottedwardparrish@gmail.com"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-amber-400/20 border border-amber-400/20 hover:border-amber-400 flex items-center justify-center text-gray-400 hover:text-amber-400 transition-all duration-300"
                aria-label="Email"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-amber-500/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Scott Parrish. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Designed with passion for visual excellence
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;